import React from 'react'

interface Answers {
  answers: { [questionId: string]: string }
}

interface Context {
  persistAnswer: (gameId: string, questionId: string, answerId: string) => void
  getSelectedAnswerId: (gameId: string, questionId: string) => string | null,
}

interface Props extends Answers {
}

interface State extends Answers {
}

const initialContext: Context = {
  persistAnswer: (gameId: string, questionId: string, answerId: string) => { return },
  getSelectedAnswerId: (gameId: string, questionId) => null
}

export const QuizAnswersContext = React.createContext<Context>(initialContext)

export const getPersistedQuestionKey = (gameId: string, questionId: string) => `${gameId}-${questionId}`

export const QuizAnswersProvider: React.SFC<Props> = ({ children, answers: initialAnswers }) => {
  const [ { answers }, setAnswers ] = React.useState<State>({ answers: initialAnswers })

  const persistAnswer = (gameId: string, questionId: string, answerId: string) => {
    setAnswers((state) => ({
      answers: { ...state.answers, [getPersistedQuestionKey(gameId, questionId)]: answerId }
    }))
  }

  const getSelectedAnswerId = (gameId: string, questionId: string) => {
    return answers[getPersistedQuestionKey(gameId, questionId)] || null
  }

  return (
    <QuizAnswersContext.Provider value={{ persistAnswer, getSelectedAnswerId }}>
      {children}
    </QuizAnswersContext.Provider>
  )
}
